<template>
  <div class="ntfc-view">
    <div v-for="(ntfc, index) in ntfcList" :key="index" class="ntfc-item">
      <mv-ntfc :text="ntfc.text" :options="ntfc.options" v-if="ntfc.text"></mv-ntfc>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import MvNtfc from "@/components/common/display/MvNtfc.vue";
import { store } from "@/store";

export default defineComponent({
  name: "NtfcView",
  components: {
    MvNtfc,
  },
  setup() {
    const ntfcList = computed(() => {
      return store.state.popup.ntfc;
    });

    return {
      ntfcList,
    };
  },
});
</script>
